import type { Catalog } from '@model/pricelist/Catalog'
import type { Promotion } from '@model/misc/Promotion'

export interface PromoDescription {
  description: string
  route: string
}

// Helper to check if string is valid JSON before parsing (prevents memory leaks from error objects)
const isValidJSON = (input: string): boolean => {
  if (!input || typeof input !== 'string') return false
  try {
    JSON.parse(input)
    return true
  } catch {
    return false
  }
}

export const isPromotionValidForCatalog =
  (catalogId: Catalog | '') =>
  (promo: Promotion): boolean => {
    if (!catalogId || catalogId === 'shop') return true

    const { description } = promo

    // Check if description is valid JSON before parsing to avoid creating error objects
    if (!description || !isValidJSON(description)) {
      console.warn('Unable to parse JSON') // Default to valid if description is not parseable
    }

    try {
      const { route = '' } = JSON.parse(description) as PromoDescription
      return route
        .split(',')
        .map((s) => s.trim())
        .includes(catalogId)
    } catch (e) {
      console.warn('Unable to parse promotion description')
    }

    return true
  }
